import React from 'react';

import { Header } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive } from 'styles/constants';

export const BasicTileContainer = ({ children, ...props }: React.PropsWithChildren<BoxProps>) => {
  const isMobile = useIsMobileBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.basicTileContainer,
        isMobile ? styles.basicTileContainerMobile : styles.basicTileContainerDesktop,
        props.style,
      ]}
    >
      {children}
    </Box>
  );
};

export const BasicTileTitle = Header.withConfig({
  variant: 'headerThree',
  margin: 0,
  marginBottom: '$2',
  color: getDesignToken('alert-info-background'),
  fontSize: {
    base: 'sm',
    md: 'lg',
  },
  lineHeight: '2xs',
  textAlign: {
    base: 'center',
    md: 'left',
  },
});

export const BasicTileImage = Picture.withConfig({
  height: 'auto',
  minHeight: { base: '$2', md: '$8' },
  maxHeight: { base: '$10', md: '$20' },
  maxWidth: { base: '$10', md: '$20' },
  marginBottom: {
    base: '$1',
    md: 0,
  },
  marginLeft: {
    base: 0,
    md: '$6',
  },
});

const styles = {
  basicTileContainer: {
    alignItems: 'center' as const,
    borderRadius: 8,
    backgroundColor: 'transparent',
    shadowColor: primitive.$black,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.15,
    shadowRadius: 2,
    elevation: 1,
  },
  basicTileContainerMobile: {
    padding: 0,
    paddingTop: 8,
    paddingBottom: 4,
    flexDirection: 'column' as const,
    justifyContent: 'center' as const,
  },
  basicTileContainerDesktop: {
    padding: 24,
    flexDirection: 'row' as const,
    justifyContent: 'flex-start' as const,
  },
};
